<template>
  <div v-loading="loading">
    <div style="display: flex;padding-right:10px">
      <!-- <div
        class="image-container"
        :style="allobj.pic_list && allobj.pic_list.length > 0 ? {
          '--bg-image': `url(${allobj.pic_list[0]})`,
          '--img-width': materialWidth + 'px',
          '--img-height': materialHeight + 'px'
        } : {}"
      >
        <img
          v-if="allobj.pic_list && allobj.pic_list.length > 0"
          ref="imageEl"
          :src="allobj.pic_list[0]"
          class="image-content"
          @load="handleImageLoad"
        >
      </div> -->
      <div>
        <div class="video-container">
          <video
            v-if="allobj.video_list && allobj.video_list.length > 0"
            ref="videoEl"
            :src="allobj.video_list[0]"
            autoplay
            loop
            muted
            controls
            class="video-box"
            @loadedmetadata="handleVideoMetadata"
          />
        </div>
      </div>
      <div style="width: 100%">
        <el-form label-width="100px">

          <!-- <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="素材尺寸"
          >
            {{ materialWidth }} × {{ materialHeight }}
          </el-form-item>
          <el-form-item
            label="剧名"
            style="margin-bottom:10px;text-align: right;"
          >
            {{ allobj.playletName }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="素材名称"
          >
            {{ allobj.creative ? allobj.creative.title1 : '' }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="投放周期"
          >
            {{ allobj.materialFirstSeen }}-{{ allobj.materialLastSeen }}
          </el-form-item> -->
          <!-- <div class="data-row">
            <div class="item_data">
              <div class="value">{{ allobj.exposureNum }}</div>
              <div class="label">曝光量</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.downloadNum }}</div>
              <div class="label">转化量</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.materialDays }}</div>
              <div class="label">投放天数</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.creativeNum }}</div>
              <div class="label">计划数</div>
            </div>
          </div> -->
        </el-form>

      </div>
    </div>
    <div
      v-if="allobj.material_type == 1"
      class="scroll-container"
    >
      <HorizontalImageScroll :images="allobj.pic_list" />
    </div>
    <div
      v-else
      class="scroll-container"
    >
      <HorizontalImageScroll :images="allobj.pic_list" />
    </div>
  </div>
</template>

<script>
import { adxpreviewinfo, adxrclickpreview } from '@/api/report/adx'
import HorizontalImageScroll from '@/views/adx/Materials/components/HorizontalImageScroll.vue'
export default {
  components: { HorizontalImageScroll },
  data() {
    return {
      table_data: [],
      imgUrl: '',
      videoUrl: '',
      materialWidth: 0,
      materialHeight: 0,
      selectedIndex: null,
      count: 1,
      timer: null,
      material_id: null,
      num: 0,
      loading: false,
      allobj: {},
      create_month: '',
      timertwo: null,
      counttwo: 1
    }
  },
  methods: {
    handleImageLoad() {
      const img = this.$refs.imageEl
      this.materialWidth = img.naturalWidth // 获取图片原始宽度
      this.materialHeight = img.naturalHeight // 获取图片原始高度
    },
    handleVideoMetadata() {
      const video = this.$refs.videoEl
      this.materialWidth = video.videoWidth
      this.materialHeight = video.videoHeight
    },
    send(val) {
      console.log('material_id', val)
      this.allobj = val
      // this.material_id = val.material_id
      // this.create_month = val.create_month
      // this.loading = true
      // this.nawewrw()
    },
    nawewrw() {
      adxrclickpreview({
        material_id: this.material_id,
        create_month: this.create_month
      }).then(res => {
        console.log('res', res)
        this.startCountdown()
      })
    },
    onweawinfo() {
      adxpreviewinfo({
        material_id: this.material_id
      })
        .then(res => {
          console.log('111', res)
          if (res.data.stop) {
            // eslint-disable-next-line eqeqeq
            if (res.data.stop == 1) {
              console.log('停止')
            }
          }
          // eslint-disable-next-line eqeqeq
          if (res.data.length == 0 && res.code == 1) {
            console.log('再次调取')
            this.startCountdowntwo()
          }
          // eslint-disable-next-line eqeqeq
          if (res.data.length != 0) {
            console.log('有数据', res.data)
            this.allobj = res.data
            // this.clearTimer()
            // this.count = 5
            this.loading = false
          }
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    onweaw() {
      adxpreviewinfo({
        material_id: this.material_id
      }).then(res => {
        console.log('res', res)
        // eslint-disable-next-line eqeqeq
        if (res.data.length == 0) {
          console.log('没数据请求其他接口')
          // eslint-disable-next-line eqeqeq
          if (this.num == 0) {
            console.log(`第${this.num}次`)
            this.nesinfo(this.material_id)
            // this.clearTimer()
            // this.count = 5
            this.num++
          } else {
            console.log(`第${this.num}次`)
            this.clearTimer()
            this.count = 5
            this.loading = false
            this.$message.error('加载失败')
          }
        } else {
          console.log('有数据')
          this.allobj = res.data
          this.clearTimer()
          this.count = 5
          this.loading = false
        }
      })
    },
    nesinfo() {
      adxrclickpreview({
        material_id: this.material_id,
        create_month: this.create_month
      }).then(res => {
        console.log('res', res)
        this.startCountdown()
      })
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.count > 1) {
          this.count--
        } else {
          this.count = 0
          // this.onweaw()
          this.onweawinfo()
          this.clearTimer()
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        console.log('⏹️ 定时器已清除')
      }
    },

    startCountdowntwo() {
      this.timertwo = setInterval(() => {
        if (this.counttwo > 1) {
          this.counttwo--
        } else {
          this.counttwo = 0
          this.zaici()
          this.clearTimertwo()
        }
      }, 1000)
    },
    clearTimertwo() {
      if (this.timertwo) {
        clearInterval(this.timertwo)
        this.timertwo = null
        console.log('⏹️ 定时器已清除再次')
      }
    },
    zaici() {
      adxpreviewinfo({
        material_id: this.material_id
      })
        .then(res => {
          console.log('zaici', res)
          // eslint-disable-next-line eqeqeq
          if (res.data.length == 0 && res.code == 1) {
            console.log('第二次没拿到')
            this.$message.error(`${res.message}`)
          }
          // eslint-disable-next-line eqeqeq
          if (res.data.length != 0) {
            console.log('第二次有数据', res.data)
            this.allobj = res.data
            this.loading = false
            // this.allobj = res.data
            // this.clearTimer()
            // this.count = 5
          }
        })
        .catch(err => {
          console.log('zaici---err', err)
        })
    },
    playVideo(val) {
      this.selectedIndex = val
      this.videoUrl = val
    },
    playPhoto(val) {
      this.selectedIndex = val
      this.imgUrl = val
    }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  width: 600px;
  height: 600px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eee;
}

.image-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--bg-image);
  background-size: cover;
  background-position: center;
  filter: blur(10px);
  z-index: 1;
}

.image-content {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  z-index: 2;
}
.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px 0;
  padding-left: 10px;
}

.scroll-wrapper {
  display: inline-block;
}

/* 每个方块的样式 */
.item {
  cursor: pointer;
  display: inline-block;
  width: 300px;
  height: 160px;
  margin-right: 10px;
  overflow: hidden;
  position: relative;
  border: 2px solid transparent;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: black;
}

.item.selected {
  border-color: #fc563d; /* 选中边框颜色 */
}

.item video {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持比例缩放，直到某一边溢出 */
  object-position: center;
  pointer-events: none;
}
.video-box {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.video-container {
  width: 400px;
  height: 544px;
  overflow: hidden;
  background: black;
}
.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 27px; /* 控制上下间距，不需要左右 padding */
  background: #f3f5f8;
  border-radius: 4px 4px 4px 4px;
  margin-left: 30px;
  margin-bottom: 20px;
}
.value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
.item_data {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px; /* 你可以根据字体大小微调 */
  flex-shrink: 0;
}
</style>
